import { render, staticRenderFns } from "./MessageBody.vue?vue&type=template&id=00dd2646&scoped=true"
import script from "./MessageBody.vue?vue&type=script&lang=js"
export * from "./MessageBody.vue?vue&type=script&lang=js"
import style0 from "./MessageBody.vue?vue&type=style&index=0&id=00dd2646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd2646",
  null
  
)

export default component.exports